// @flow
export { KanoonModule } from './kanoon-module'